import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import Drawer from 'components/Drawer'

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export const CenterDriveIcon = styled.div`
  justify-content: center;
`
export const CardRowDrive = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 0 25px 25px 25px;
  gap: 5px;
`
export const CompanyDriveInfoName = styled.div`
  margin-top: 18px;
  margin-bottom: 22px;
  text-align: center;
  font-size: 1.25rem;
  color: ${COLORS.GREY_T_20};
  font-weight: 700;
`
export const DomainDriveInfoName = styled.div`
  font-size: 0.95rem;
  color: ${COLORS.GREY_T_60};
  font-weight: 500;
`
export const ItemsFlex = styled(Flex)`
  padding: 0.3rem 0.8rem;
  align-items: center;
  margin: 3%;
`
export const LightText = styled(Flex)`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: ${COLORS.PRIMARY_GREY_T_50};
  gap: 10px;
  flex: 1 1 0;
  align-items: center;
`
export const BoldText = styled.div`
  font-size: 0.975rem;
  font-weight: 700;
  line-height: 1.25rem;
  color: ${COLORS.PRIMARY_GREY_T_30};
  flex: 1 1 0;
  margin-left: 2rem;
`
export const ModeText = styled(BoldText)`
  text-transform: capitalize;
`
export const LocationText = styled.div`
  max-width: 60%;
  font-size: 0.975rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: ${COLORS.PRIMARY_GREY_T_50};
  margin-left: 2rem;
`
export const FooterFlex = styled(Flex)`
  align-items: center;
  justify-content: space-around;
`

export const TopRightDriveButton = styled(Flex)`
  gap: 15px;
  padding: 10px;
  justify-content: space-around;
  margin: auto;
`
export const CardDriveRow = styled(Flex)`
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: space-around;
`
export const CountDriveContainer = styled(Flex)`
  padding: 2rem;
  justify-content: center;
  align-items: center;
`
export const ViewButton = styled.div`
  font-weight: 600;
  white-space: nowrap;
  text-align: center;
  background-image: none;
  border: 1px solid transparent;
  box-shadow: 0 2px 0 rgb(0 0 0 / 2%);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  touch-action: manipulation;
  height: 32px;
  padding: 4px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: rgb(50, 73, 215);
  border-color: #d9d9d9;
  background: #e4e7ea;
`
